import { ArrowUp, Loader2, Paperclip } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ComposeMode } from '../types';
import { Button } from '~/components/ui/button';
import { cn } from '~/lib/utils';

type MessageInputActionsProps = {
  mode: ComposeMode;
  onAttach?: () => void;
  isBusy: boolean;
};

export function MessageInputActions({
  mode,
  onAttach,
  isBusy,
}: MessageInputActionsProps) {
  const { t } = useTranslation('mailbox');
  let submitIcon = <ArrowUp className="size-4" strokeWidth={2.5} />;

  if (isBusy) {
    submitIcon = <Loader2 className="size-4 animate-spin" strokeWidth={2.5} />;
  }

  const label = {
    forward: t('Forward'),
    new: t('Send'),
    reply: t('Reply'),
    'reply-all': t('Reply all'),
  }[mode];

  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center">
        <ActionButton
          label={t('Attach file')}
          icon={Paperclip}
          onClick={onAttach}
          disabled={isBusy}
        />
      </div>

      <Button type="submit" shape="pill" disabled={isBusy}>
        {label}
        {submitIcon}
      </Button>
    </div>
  );
}

function ActionButton({
  icon: Icon,
  iconClassName,
  label,
  onClick,
  disabled = false,
}: {
  icon: typeof Paperclip;
  iconClassName?: string;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <Button
      type="button"
      variant="muted"
      size="icon-sm"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
    >
      <Icon className={cn('size-4', iconClassName)} strokeWidth={2.5} />
    </Button>
  );
}
